module.exports = __webpack_public_path__ + "mptt-viewer.component.html";


//////////////////
// WEBPACK FOOTER
// ./core/mptt-viewer/mptt-viewer.component.html
// module id = 553
// module chunks = 0